/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Parametric_DescInputs */

const en_cad_features_parametric_desc = /** @type {(inputs: Cad_Features_Parametric_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geometric and dimensional constraints with expression parameters. Change a value and the drawing updates itself.`)
};

/**
* | output |
* | --- |
* | "Geometric and dimensional constraints with expression parameters. Change a value and the drawing updates itself." |
*
* @param {Cad_Features_Parametric_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_parametric_desc = /** @type {((inputs?: Cad_Features_Parametric_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Parametric_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_parametric_desc(inputs)
});
export { cad_features_parametric_desc as "cad.features.parametric_desc" }